import axios from 'axios';
import numeral from 'numeral';
import Vue from 'vue';

Vue.prototype.$score = (score, format = '0.0') => {
    return numeral(score).format(format);
};

Vue.prototype.$isIOS = window.iPhoneApp || false;

Vue.prototype.$isDevEnv = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'local';

Vue.prototype.$http = axios;

Vue.prototype.openIOSLink = url => {
    if (!Vue.prototype.$isIOS) {
        window.location.href = url;

        return;
    }

    // window.webkit.messageHandlers.interceptor.postMessage({
    //     type: 'nativeFunction',
    //     data: 'test',
    // });

    window.webkit.messageHandlers.openExternalLink.postMessage(url);
};
